import { Dialog, Transition } from '@headlessui/react'
import { Fragment } from 'react'
import ReactPlayer from 'react-player'

interface Props {
  closeModal: () => void
  isOpen: boolean
  content: any
}

export const VideoModal: React.FC<Props> = ({ closeModal, isOpen, content }) => {
  return (
    <>
      <Transition appear show={isOpen} as={Fragment}>
        <Dialog as="div" className="relative z-[90]" onClose={closeModal}>
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-black bg-opacity-25" />
          </Transition.Child>

          <div className="fixed inset-0 overflow-y-auto  w-full h-full">
            <div className="flex  items-center justify-center text-center w-full h-full">
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 scale-95"
                enterTo="opacity-100 scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 scale-100"
                leaveTo="opacity-0 scale-95"
              >
                <Dialog.Panel className="w-full h-full z-30 transform overflow-hidden  bg-black  text-right align-middle shadow-xl transition-all">
                  <button className="text-white absolute right-10 top-10  z-[900]" onClick={() => closeModal()}>
                    X
                  </button>
                  {content}
                  <div className="w-full">
                    {/* @ts-ignore: Unreachable code error */}
                    <ReactPlayer url={content} width={window.innerWidth} height={window.innerHeight} playing />
                  </div>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition>
    </>
  )
}
